export default __webpack_public_path__ + "static/media/censuringstrike3.62360671.png";